module.exports = __webpack_public_path__ + "static/media/Moon.a7d2a948.svg";